import { JsonApiDocumentInterface } from '../interfaces/json-api-document';
import { JsonApiIdentifierInterface } from '../interfaces/json-api-identifier-interface';
import { JsonApiDocument } from './json-api-document';
import { JsonApiIdentifier } from './json-api-identifier';

export class JsonApiManyIdentifiersDocument extends JsonApiDocument<
  JsonApiIdentifier[]
> {
  constructor(
    document: JsonApiDocumentInterface<JsonApiIdentifierInterface[]>
  ) {
    super(document);
    if (document.data) {
      const identifiers = document.data.map(
        (data) => new JsonApiIdentifier(data)
      );
      this._data = identifiers;

      if (document.included) {
        this._included = document.included.map((resource) =>
          this.createResource(resource)
        );
        this.populateResources(document);
      }
    }
  }
}
